;(() => {
  // IDs fournis
  const KNIFE_PRODUCT_ID  = 15838388224345; // produit couteau (Esperluète de table)
  const ENGRAVING_VARIANT = 56274599018841; // variant "Gravure" à 7€

  const MODAL_ID = 'knife-config-modal';
  const BTN_SEL  = '#kc-customize-btn';

  const qs  = (s, r=document)=>r.querySelector(s);
  const qsa = (s, r=document)=>Array.from(r.querySelectorAll(s));

  function lockScroll(lock){
    const html = document.documentElement;
    if (lock) { html.style.overflow = 'hidden'; }
    else { html.style.overflow = ''; }
  }


  function openModal() {
    const modal = qs('#' + MODAL_ID);
    if (!modal) return console.warn('Knife modal not found:', MODAL_ID);

    // Passe les IDs à la popup (utile pour la suite)
    modal.dataset.productId = String(KNIFE_PRODUCT_ID);
    modal.dataset.engravingVariantId = String(ENGRAVING_VARIANT);

modal.hidden = false;
modal.setAttribute('aria-hidden', 'false');
lockScroll(true);

// 👉 force a refresh of UI + prices on open
modal.dispatchEvent(new CustomEvent('kc:refresh', { bubbles: true }));

    // Focus trap minimal
    const f = qsa('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])', modal)
      .filter(el => !el.disabled && el.offsetParent !== null);
    const first = f[0], last = f[f.length-1];
    function trap(e){
      if (e.key !== 'Tab' || f.length === 0) return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    modal.addEventListener('keydown', trap);
    modal.__trap = trap;

    (first || modal).focus();
  }

  function closeModal() {
    const modal = qs('#' + MODAL_ID);
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    lockScroll(false);
    if (modal.__trap) modal.removeEventListener('keydown', modal.__trap);
  }

  function bind(){
    const btn = qs(BTN_SEL);
    if (!btn) return;

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });

    // Fermeture via overlay / bouton ✕
    document.addEventListener('click', (e) => {
      const isClose = e.target.closest('[data-kc-close]');
      const isOverlay = e.target.closest('#' + MODAL_ID + ' .kc-backdrop');
      if (isClose || isOverlay) { e.preventDefault(); closeModal(); }
    });

    // Fermeture via ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });
  }

  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();

/* 1) RADIOS → SELECT glue */
(() => {
  const modal = document.getElementById('knife-config-modal');
  if (!modal) return;

  const sizeSel = modal.querySelector('#kc-size');        // hidden select (source of truth)
  const items   = Array.from(modal.querySelectorAll('.kc-size-item'));
  const radios  = Array.from(modal.querySelectorAll('.kc-size-radio'));

  function setSize(val){
    if (!sizeSel) return;
    sizeSel.value = String(val);
    sizeSel.dispatchEvent(new Event('change', { bubbles:true })); // notify controller

    // style sélectionné
    items.forEach(li => {
      const r = li.querySelector('.kc-size-radio');
      li.classList.toggle('is-checked', r && r.value === String(val));
    });
  }

  // click / change sur radios (et ligne entière)
  radios.forEach(r => {
    r.addEventListener('change', () => { if (r.checked) setSize(r.value); });
    r.closest('.kc-size-option')?.addEventListener('click', () => {
      if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', {bubbles:true})); }
    });
  });

  // Init depuis le select caché (fallback 1)
  const initial   = sizeSel?.value || '1';
  const initRadio = modal.querySelector(`.kc-size-radio[value="${CSS.escape(initial)}"]`) || radios[0];
  if (initRadio) { initRadio.checked = true; setSize(initRadio.value); }
})();


;(() => {
  // DROPDOWN CUSTOM (formats)
  const modal = document.getElementById('knife-config-modal');
  if (!modal) return;

  const ddWrap = modal.querySelector('[data-kc-dd]');
  if (!ddWrap) return;

  const nativeId   = ddWrap.getAttribute('for');
  const nativeSel  = modal.querySelector('#' + nativeId);
  const btn        = ddWrap.querySelector('.kc-dd__button');
  const label      = ddWrap.querySelector('.kc-dd__label');
  const list       = ddWrap.querySelector('.kc-dd__list');

  const open = () => {
    list.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    ddWrap.setAttribute('aria-expanded', 'true');
    (list.querySelector('[aria-selected="true"]') || list.firstElementChild)?.focus();
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKeyGlobal);
  };
  const close = () => {
    list.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    ddWrap.setAttribute('aria-expanded', 'false');
    document.removeEventListener('click', onDocClick);
    document.removeEventListener('keydown', onKeyGlobal);
    btn.focus();
  };
  const onDocClick = (e) => { if (!ddWrap.contains(e.target)) close(); };
  const onKeyGlobal = (e) => { if (e.key === 'Escape') close(); };

  function build() {
    list.innerHTML = '';
    Array.from(nativeSel.options).forEach((opt) => {
      const li = document.createElement('li');
      li.className = 'kc-dd__option';
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '-1');
      li.dataset.value = opt.value;
      li.textContent = opt.textContent;
      if (opt.selected) li.setAttribute('aria-selected', 'true');
      list.appendChild(li);
    });
    label.textContent = nativeSel.selectedOptions[0]?.textContent || '';
  }

  function selectValue(val){
    nativeSel.value = val;
    nativeSel.dispatchEvent(new Event('change', { bubbles:true }));
    list.querySelectorAll('.kc-dd__option').forEach(li => {
      li.toggleAttribute('aria-selected', li.dataset.value === val);
    });
    const chosen = list.querySelector(`.kc-dd__option[data-value="${CSS.escape(val)}"]`);
    label.textContent = chosen?.textContent || '';
  }

  btn.addEventListener('click', () => { list.hidden ? open() : close(); });

  list.addEventListener('click', (e) => {
    const li = e.target.closest('.kc-dd__option');
    if (!li) return;
    selectValue(li.dataset.value);
    close();
  });

  list.addEventListener('keydown', (e) => {
    const items = Array.from(list.querySelectorAll('.kc-dd__option'));
    const current = document.activeElement.closest('.kc-dd__option') || items[0];
    let i = items.indexOf(current);
    if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(i+1, items.length-1)].focus(); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); items[Math.max(i-1, 0)].focus(); }
    if (e.key === 'Home')      { e.preventDefault(); items[0].focus(); }
    if (e.key === 'End')       { e.preventDefault(); items[items.length-1].focus(); }
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectValue(document.activeElement.dataset.value); close(); }
  });

  nativeSel.addEventListener('change', () => {
    const val = nativeSel.value;
    list.querySelectorAll('.kc-dd__option').forEach(opt => {
      opt.toggleAttribute('aria-selected', opt.dataset.value === val);
    });
    label.textContent = nativeSel.selectedOptions[0]?.textContent || '';
  });

  build();
})();

;(() => {
  // AJOUT AU PANIER (bulk + gravure + toast + fermeture)
  const modal = document.getElementById('knife-config-modal');
  if (!modal) return;

  const addBtn        = modal.querySelector('[data-kc-add]');
  const sizeSel       = modal.querySelector('#kc-size');
  const engraveToggle = modal.querySelector('[data-kc-engraving-toggle]');
  const engraveInput  = modal.querySelector('[data-kc-engraving-text]');
  const totalOut      = modal.querySelector('[data-kc-total]');
  if (!addBtn) return;

  const engraveFontRadios = () =>
    Array.from(modal.querySelectorAll('input[name="kc-engraving-font"]'));

  const getEngravingFont = () => {
    const checked = modal.querySelector('input[name="kc-engraving-font"]:checked');
    return checked ? checked.value : 'classique';
  };


  const qs  = (s, r=document)=>r.querySelector(s);
  const qsa = (s, r=document)=>Array.from(r.querySelectorAll(s));

  function moneyToCents(m){
    if (!m) return 0;
    const n = String(m).replace(/[^\d,.-]/g,'').replace(',', '.');
    return Math.round(parseFloat(n || '0') * 100);
  }
  function totalAllocated(){
    return qsa('[data-kc-qty]', modal)
      .reduce((sum, el) => sum + (parseInt(el.textContent||'0',10)||0), 0);
  }
  function readJSON(selector, fallback) {
    try {
      const el = modal.querySelector(selector);
      if (!el) return fallback;
      return JSON.parse(el.textContent.trim());
    } catch(e){ return fallback; }
  }

  // IDs depuis le <script data-kc-data> (fiable même avant ouverture)
  const idsFromScript   = readJSON('script[data-kc-data]', {});
  const ENGRAVING_VARIANT = Number(idsFromScript.engravingVariantId || modal.dataset.engravingVariantId || 0) || 0;

  function collectVariantLines(){
    const lines = [];
    qsa('.kc-variant-row', modal).forEach(row => {
      const qty = parseInt(qs('[data-kc-qty]', row)?.textContent || '0', 10) || 0;
      if (qty <= 0) return;
      const id = Number(row.getAttribute('data-variant-id')) || 0;
      if (!id) return;

      const materialName = qs('.kc-material-name', row)?.textContent?.trim() || '';
      const surcharge = Number(row.getAttribute('data-surcharge')) || 0;
      lines.push({
        id,
        quantity: qty,
        properties: {
          '_KC - Matériau': materialName,
          '_KC - Surcote (€)': surcharge
        }
      });
    });
    return lines;
  }

function collectEngravingLine(){
  if (!engraveToggle || !engraveToggle.checked) return null;

  const data = readJSON('script[data-kc-data]', {});
  const idFromDataset = Number(modal.dataset.engravingVariantId || 0);
  const idFromScript  = Number(data.engravingVariantId || 0);
  const ENGR_ID = idFromDataset || idFromScript || 0;

  if (!ENGR_ID) throw new Error("Variante de gravure introuvable.");

  const txt = (engraveInput?.value || '').trim();
  if (!txt) {
    if (engraveInput) {
      engraveInput.focus();
      engraveInput.setAttribute('aria-invalid', 'true');
      engraveInput.style.borderColor = '#c23b3b';
    }
    throw new Error("Veuillez saisir votre texte de gravure.");
  } else {
    if (engraveInput) {
      engraveInput.removeAttribute('aria-invalid');
      engraveInput.style.borderColor = '';
    }
  }

  const font = getEngravingFont();
  const fontLabel =
    font === 'manuscrite' ? 'manuscrite' :
    font === 'moderne' ? 'moderne' :
    'classique';

  const N = parseInt(sizeSel?.value || '1', 10) || 1;

  return {
    id: ENGR_ID,
    quantity: N,
    properties: {
      _engraving: 'true',
      personnalisation: '"' + txt + '" gravée en police ' + fontLabel
    }
  };
}

function safeRenderCart(cart, sections) {
  // sectionsToRender: [{id, section, selector}]
  const toRender = (typeof cart.getSectionsToRender === 'function')
    ? cart.getSectionsToRender()
    : [];

  toRender.forEach((s) => {
    const host = document.getElementById(s.id);
    if (!host) return;

    const target = s.selector ? host.querySelector(s.selector) : host;
    if (!target) return;

    const html = sections?.[s.section];
    if (typeof html !== 'string') return;

    target.innerHTML = html;
  });

  // bonus: update cart count bubble if your theme uses it
  // (si tu as un badge type [data-cart-count], ça l’update)
  fetch((window.routes && window.routes.cart_url) ? `${window.routes.cart_url}.js` : '/cart.js', {
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(r => r.json())
    .then(cartJson => {
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = String(cartJson.item_count || 0);
      });
    })
    .catch(() => {});
}

async function fetchCartSections(cart) {
  const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  const keys = cart.getSectionsToRender().map(s => s.section);

  const res = await fetch(
    `${cartUrl}?sections=${encodeURIComponent(keys.join(','))}`,
    { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
  );

  return res.json();
}



async function addToCart(items, attributes) {
  const cartUI =
    document.querySelector('cart-drawer') ||
    document.querySelector('cart-notification');

  const cartDrawer = document.querySelector('cart-drawer');

  const addUrl =
    (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

  const config = (typeof window.fetchConfig === 'function')
    ? window.fetchConfig('javascript')
    : { method: 'POST', headers: { 'Accept': 'application/json' } };

  config.headers = config.headers || {};
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();

  items.forEach((it, i) => {
    formData.append(`items[${i}][id]`, String(it.id));
    formData.append(`items[${i}][quantity]`, String(it.quantity));

    if (it.properties && typeof it.properties === 'object') {
      Object.entries(it.properties).forEach(([k, v]) => {
        if (v == null || v === '') return;
        formData.append(`items[${i}][properties][${k}]`, String(v));
      });
    }
  });

  if (attributes && typeof attributes === 'object') {
    Object.entries(attributes).forEach(([k, v]) => {
      if (v == null || v === '') return;
      formData.append(`attributes[${k}]`, String(v));
    });
  }

  if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
    const ids = cartUI.getSectionsToRender().map(s => s.id);
    formData.append('sections', ids);
    formData.append('sections_url', window.location.pathname);

    if (typeof cartUI.setActiveElement === 'function') {
      cartUI.setActiveElement(document.activeElement);
    }
  }

  config.body = formData;

  const res = await fetch(addUrl, config);
  const json = await res.json();

  if (json && json.status) {
    throw new Error(json.description || json.message || 'Erreur ajout au panier');
  }

  if (cartUI && typeof cartUI.renderContents === 'function') {
    cartUI.renderContents(json);

    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      const inner = cartDrawer.querySelector('#CartDrawer');
      if (inner) inner.classList.remove('is-empty');
      const drawerInner = cartDrawer.querySelector('.drawer');
      if (drawerInner) drawerInner.classList.remove('is-empty');
    }

    requestAnimationFrame(() => {
      if (cartUI.tagName && cartUI.tagName.toLowerCase() === 'cart-drawer' && typeof cartUI.open === 'function') {
        cartUI.open();
      } else {
        document.querySelector('[data-cart-drawer-toggle]')?.click();
      }
    });

    return json;
  }

  window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  return json;
}



  function setLoading(state){
    addBtn.setAttribute('aria-busy', state ? 'true' : 'false');
    const spinner = addBtn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !state);
  }
  function toast(msg){
    let t = document.getElementById('kc-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'kc-toast';
      t.style.cssText = 'position:fixed;left:50%;top:20px;transform:translateX(-50%);background:#2f2f2f;color:#fff;padding:10px 14px;z-index:10000;opacity:0;transition:opacity .2s';
      document.body.appendChild(t);
    }
    t.textContent = msg; t.style.opacity = '1';
    setTimeout(()=>{ t.style.opacity='0'; }, 1600);
  }
  function closeModal(){
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (modal.__trap) modal.removeEventListener('keydown', modal.__trap);
  }

 addBtn.addEventListener('click', async () => {
  // Validation allocation
  const N = parseInt(sizeSel?.value || '1', 10) || 1;
  const allocated = totalAllocated();
  if (allocated !== N) {
    toast(`Attribue ${N} couteau(x) (${allocated}/${N})`);
    return;
  }

  // Lignes variantes (couteaux)
  const items = collectVariantLines();
  if (!items.length) {
    toast('Sélectionne au moins 1 couteau 🙂');
    return;
  }

  // Ligne gravure (si cochée) — bloque si texte vide
  let engr = null;
  try {
    engr = collectEngravingLine(); // peut lever une erreur si gravure cochée mais vide
  } catch (e) {
    toast(e.message || 'Texte de gravure requis.');
    // feedback visuel déjà géré dans collectEngravingLine() (focus + aria-invalid)
    return;
  }
  if (engr) items.push(engr);

  // Attributs panier
  const totalShownCents = moneyToCents(totalOut?.textContent || '');
  const attributes = {
    'kc_bundle_size': String(N),
    'kc_bundle_total_cents': String(totalShownCents),
    'kc_phase_label': (qs('[data-kc-phase]', modal)?.textContent || '').trim()
  };

  try {
    setLoading(true);
    await addToCart(items, attributes);
    document.dispatchEvent(new CustomEvent('kc:cart:updated'));
    closeModal();

    // document.dispatchEvent(new CustomEvent('theme:cart:open'));
  } catch (err) {
    console.error(err);
    toast(err.message || 'Impossible d’ajouter au panier');
  } finally {
    setLoading(false);
  }
});

})();
